<template>
<div>
  <program-quick-link-section
    v-if="type === 'programs' || type === 'adjoints' || type === 'summer_research'"
    :type="type"
    :quick-link-data="quickLink"
    :event-datas="eventDatas"
  />
  <workshop-msriup-quick-link-section
    v-if="type === 'workshops' || type === 'msri_ups' || type === 'may_ups' || type === 'summer_schools'"
    :type="type"
    :quick-link-data="quickLink"
    :event-datas="eventDatas"
  />
  <seminar-quick-link-section
    v-if="type === 'seminars'"
    :type="type"
    :quick-link-data="quickLink"
  />
</div>
</template>

<script>
import mixin from '@/utils/mixin.js'
import ProgramQuickLinkSection from '@/components/QuickLink/ProgramQuickLinkSection.vue'
import WorkshopMsriupQuickLinkSection from '@/components/QuickLink/WorkshopMsriupQuickLinkSection.vue'
import SeminarQuickLinkSection from '@/components/QuickLink/SeminarQuickLinkSection.vue'

export default {
    name: "ProgramAdminToolSection",
    components: { WorkshopMsriupQuickLinkSection, ProgramQuickLinkSection, SeminarQuickLinkSection },
    mixins: [mixin],
    props: ["type", "quickLink", "eventDatas"],
}
</script>
